/* IceSwipe: add to cart without leaving the page, then open the Essential Cart Drawer. */
(function () {
  var SELECTOR = '.is-pdp form[action*="/cart/add"], #is-product form[action*="/cart/add"]';

  function openDrawer() {
    var api = window.essentialCartApi;
    if (!api) return false;
    var done = function () { try { if (!api.isOpen || !api.isOpen()) api.openCart(); } catch (e) {} };
    try {
      var r = api.refreshCart && api.refreshCart();
      if (r && typeof r.then === 'function') { r.then(done, done); } else { setTimeout(done, 150); }
    } catch (e) { done(); }
    return true;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches(SELECTOR)) return;
    if (!window.essentialCartApi || !window.fetch) return; /* no drawer app: normal behaviour (cart page) */
    event.preventDefault();

    var buttons = document.querySelectorAll('[data-is-atc], .is-sticky .is-btn');
    buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) { alertMessage(form, (r.data && (r.data.description || r.data.message)) || 'Could not add to cart.'); return; }
        if (!openDrawer()) window.location.href = '/cart';
      })
      .catch(function () { form.submit(); })
      .finally(function () { buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); });
  }, true);

  function alertMessage(form, text) {
    var el = form.querySelector('.is-cart-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'is-cart-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#b42318;font-size:14px;margin:10px 0 0';
      form.appendChild(el);
    }
    el.textContent = text;
  }
})();